import glitchPlaceholderUrl from "@/assets/glitch-placeholder.png"

/** Glich silhouette — only for selected missing-image surfaces (not global). */
export const GLITCH_PLACEHOLDER_URL = glitchPlaceholderUrl
